import { JupiterTheme } from '@jupiterone/jupiter-web-toolkit/src/theme/types';
import { Checkbox, FormControlLabel } from '@material-ui/core';
import { createStyles, withStyles, WithStyles } from '@material-ui/styles';
import clsx from 'clsx';
import React, { ElementType } from 'react';
const styles = (theme: JupiterTheme) =>
  createStyles({
    itemBox: {
      display: 'flex',
      marginLeft: -8,
      marginRight: -8,
      paddingLeft: 0,
      position: 'relative',
      '&:hover': {
        background: theme.palette.coolGrey[50],
        '& $checkbox': {
          left: 18,
          opacity: 1,
          transition: '0.5s cubic-bezier(0.2, 0.8, 0.2, 1)',
          transform: 'scale(1)',
        },
        '& $itemTitle': {
          marginLeft: 16,
          opacity: 1,
          transition: '0.5s cubic-bezier(0.2, 0.8, 0.2, 1)',
        },
      },
    },
    itemBoxWithIcon: {
      paddingLeft: theme.spacing(2.125),
      '& $checkbox': {
        left: -24,
        marginRight: 3,
      },
      '& $itemTitle': {
        marginLeft: 4,
      },
      '&:hover': {
        '& $checkbox': {
          left: 0,
        },
        '& svg': {
          left: 33,
          transition: '0.5s cubic-bezier(0.2, 0.8, 0.2, 1)',
        },
        '& $itemTitle': {
          marginLeft: 29,
        },
      },
    },
    checkbox: {
      height: 20,
      left: -7,
      marginRight: 6,
      opacity: 0,
      transition: '0.25s cubic-bezier(0.2, 0.8, 0.2, 1)',
      transform: 'scale(1.2)',
      width: 20,
    },
    checked: {
      opacity: 1,
      '& + $itemTitle': {
        opacity: 1,
      },
    },
    typeIcon: {
      height: 19,
      position: 'absolute',
      top: 4,
      transition: '0.25s cubic-bezier(0.2, 0.8, 0.2, 1)',
      left: 5,
      width: 19,
    },
    label: {
      marginRight: 0,
      padding: theme.spacing(0.25, 1, 0.5, 0),
      width: 'calc(100% + 8px)',
    },
    itemTitle: {
      fontSize: 14,
      fontWeight: 400,
      overflow: 'hidden',
      opacity: 0.5,
      marginLeft: -4,
      textOverflow: 'ellipsis',
      transition: '0.25s cubic-bezier(0.2, 0.8, 0.2, 1)',
      whiteSpace: 'nowrap',
    },
  });

interface Props extends WithStyles<typeof styles> {
  onSelect: (e: any) => void;
  checked: boolean;
  labelText: string;
  LoadedIcon?: ElementType;
}

export const FilterPanelCheckbox = ({
  onSelect,
  checked,
  classes,
  labelText,
  LoadedIcon,
}: Props) => {
  return (
    <div
      className={clsx(classes.itemBox, LoadedIcon && classes.itemBoxWithIcon)}
    >
      <FormControlLabel
        control={
          <Checkbox
            color="primary"
            classes={{
              root: classes.checkbox,
              checked: classes.checked,
            }}
            checked={checked}
            onClick={onSelect}
          />
        }
        label={
          <>
            {labelText}
            {LoadedIcon && <LoadedIcon className={classes.typeIcon} />}
          </>
        }
        classes={{ label: classes.itemTitle }}
        className={classes.label}
      />
    </div>
  );
};
export default withStyles(styles)(FilterPanelCheckbox);
